import React, {useState} from 'react';
import {Box, FormControl, Input, InputLabel, Typography} from '@deere/fuel-react';
import {Controller} from "react-hook-form";

export const FeedbackComments = ({
                             control,
                             showLabel,
                             disabled = false,
                             name,
                             generalComments,
                             rowsHeight = 4,
                             placeholder,
                             required = false
                         }) => {
    const [characterCount, setCharacterCount] = useState(generalComments ? generalComments.length : 0);

    return (
        <FormControl disabled={disabled} fullWidth>
            {showLabel && (<InputLabel htmlFor="stakeholder">
                General Comments
                <Box display="inline" ml={1}>
                    <Typography size="xs" component="span" color="tertiary">
                        (Optional)
                    </Typography>
                </Box>
            </InputLabel>)}
            <Controller
                control={control}
                defaultValue={generalComments}
                name={name}
                value={generalComments}
                rules={{required: {value: required, message: "This field is required"}}}
                render={({onChange, value}) => (
                    <Input
                        onChange={(e) => {
                            setCharacterCount(e.target.value.length)
                            onChange(e.target.value)
                        }}
                        value={value}
                        label={"Text Value"}
                        multiline={true}
                        aria-multiline={true}
                        placeholder={placeholder}
                        minRows={rowsHeight}
                        required={required}
                        rowsMin={rowsHeight}
                        inputProps={
                            {maxLength: 750}
                        }/>
                )}
            />
            <Box display="flex" justifyContent="flex-end">
                <Typography variant="caption" color="secondary" component="p">
                    {characterCount} / 750
                </Typography>
            </Box>
        </FormControl>
    )
}
